var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_vm._t("default"),_c('span',{staticClass:"border"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }